import { call, put, takeEvery } from "redux-saga/effects";
import { callApi } from "../../api/Api";
import {
  stopLoading,
  showErrorMessage,
  startLoading,
} from "../layout/action";
import { GET_ORDER_PDF_STATES, setDriverOrderPDFStates } from "./action";

export function* callGetDriverOrderPDFStates(action) {
  try {
    yield put(startLoading());
    const stateResponse = yield call(callApi, {
      responseType: "arraybuffer",
      method: "GET",
      url: `/order-actions/download-order-receipt/${action.payload.OrderId}`,
    });

    const { data } = stateResponse;
    const file = new Blob([stateResponse.data], { type: "application/pdf" });
    const url = URL.createObjectURL(file);
    window.open(url);

    yield put(setDriverOrderPDFStates(data));
    yield put(stopLoading());
  } catch (err) {
    yield put(stopLoading());
    yield put(showErrorMessage({ error: err, title: "Get Order list" }));
  }
}

export function* watchGetDriverOrderPDFStates() {
  yield takeEvery(GET_ORDER_PDF_STATES, callGetDriverOrderPDFStates);
}
